var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"us_module"},_vm._l((_vm.usModule),function(umItem,index){return _c('div',{key:index,staticClass:"usM_item",on:{"click":function($event){return _vm.usModuleLink(index+1)}}},[_vm._v("\n    "+_vm._s(umItem.name)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16cbb04b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/views/header/aboutUs.vue
// module id = null
// module chunks = 